import { Box, Divider, Paper, Typography } from "@mui/material";
import { t } from "i18next";
import WorkerLineChart from "./lineChart";

function ReportChart({ chartData, isLoading }) {
  return (
    <Paper sx={{ borderRadius: 1, mt: 3 }}>
      <Typography variant="h5" fontWeight={600} p={2}>
        {t("totalEarnings")}
      </Typography>
      <Divider />
      {chartData?.length > 0 ? (
        <Box p={2}>
          <WorkerLineChart chartData={chartData} />
        </Box>
      ) : (
        chartData?.length === 0 &&
        isLoading === false && (
          <Typography
            variant="h6"
            fontWeight={600}
            my={2}
            textAlign={"center"}
            p={2}
          >
            {t("noDataFound")}
          </Typography>
        )
      )}
    </Paper>
  );
}

export default ReportChart;
